import React, {Component} from "react";
import {Redirect} from "react-router";
import {Grid, Row, Col, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import Switch from "components/CustomSwitch";
import apiClient from "api/client";
import connect from "react-redux/es/connect/connect";
import NotificationSystem from "react-notification-system";
import Card from "../../components/Card/Card.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import ModalSave from "../../components/CustomModals/ModalSave";
import PlaylistScaffoldNotice from "../../components/Playlists/PlaylistScaffoldNotice.jsx";
import PlaylistScaffoldTable from "../../components/Playlists/PlaylistScaffoldTable.jsx";
import {userActions} from "../../authentication/_actions";
import {style} from "../../variables/Variables";
import {
    categoryScopeOptions,
    formatCategoryScope,
    formatPlaylistDelivery,
    formatPlaylistType,
    playlistTypeOptions
} from "../../components/Playlists/playlistScaffoldData";
import {withNamespaces} from "react-i18next";

const defaultCategory = () => ({
    playlist_category_id: "new",
    playlist_category_position: 1,
    playlist_category_status: 1,
    playlist_category_name: "",
    playlist_category_description: "",
    playlist_type: "sports",
    playlist_category_scope: "global",
    playlist_count: 0
});

class EditPlaylistCategory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            _notificationSystem: null,
            loading: false,
            showSaveModal: false,
            redirect: false,
            categoryRedirect: false,
            back_button_text: "Cancel",
            category: defaultCategory(),
            usageRows: []
        };
    }

    componentDidMount() {
        this.setState({_notificationSystem: this.refs.notificationSystem}, this.loadPageData);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.handle !== this.props.match.params.handle) {
            this.loadPageData();
        }
    }

    getAxiosConfig = () => {
        let user = JSON.parse(localStorage.getItem("user"));

        if (!user || !user.token) {
            this.props.dispatch(userActions.logoutUnauthorized());
            return null;
        }

        return {
            headers: {
                "X-Id-Token": user.token,
                "Content-Type": "application/json"
            }
        };
    }

    handleApiError = (error) => {
        this.setState({loading: false, showSaveModal: false});

        if (error && error.response && error.response.status === 401) {
            this.props.dispatch(userActions.logoutUnauthorized(error));
            return;
        }

        this.notification("failed");
        console.log(error);
    }

    normalizeCategory = (record = {}) => ({
        playlist_category_id: record.playlist_category_id || "new",
        playlist_category_position: record.playlist_category_position || 1,
        playlist_category_status: Number(record.playlist_category_status) === 1 ? 1 : 0,
        playlist_category_name: record.playlist_category_name || "",
        playlist_category_description: record.playlist_category_description || "",
        playlist_type: record.playlist_type || "sports",
        playlist_category_scope: record.playlist_category_scope || "global",
        playlist_count: record.playlist_count || 0
    })

    loadPageData = () => {
        const {handle} = this.props.match.params;
        const axiosConfig = this.getAxiosConfig();

        if (!axiosConfig) {
            return;
        }

        this.setState({
            loading: true,
            showSaveModal: false,
            redirect: false,
            categoryRedirect: false,
            back_button_text: handle === "new" ? "Cancel" : "Back",
            usageRows: []
        });

        if (handle === "new") {
            apiClient.get(process.env.REACT_APP_API_URL + "/PlaylistCategory/position", axiosConfig)
                .then((res) => {
                    const nextPosition = Array.isArray(res.data) && res.data[0] ? res.data[0].PlaylistCategoryPosition : 1;

                    this.setState({
                        category: {
                            ...defaultCategory(),
                            playlist_category_position: nextPosition || 1
                        },
                        loading: false
                    });
                })
                .catch(this.handleApiError);

            return;
        }

        Promise.all([
            apiClient.get(process.env.REACT_APP_API_URL + "/PlaylistCategory/" + handle, axiosConfig),
            apiClient.get(process.env.REACT_APP_API_URL + "/PlaylistCategory/" + handle + "/playlists", axiosConfig)
        ]).then(([categoryRes, playlistsRes]) => {
            const categoryRecord = Array.isArray(categoryRes.data) && categoryRes.data[0] ? categoryRes.data[0] : defaultCategory();

            this.setState({
                category: this.normalizeCategory(categoryRecord),
                usageRows: Array.isArray(playlistsRes.data) ? playlistsRes.data : [],
                loading: false
            });
        }).catch(this.handleApiError);
    }

    handleInputChange = (event) => {
        const {name, value} = event.target;

        this.setState((prevState) => ({
            category: {
                ...prevState.category,
                [name]: value
            }
        }));
    }

    handleSwitch = (value) => {
        this.setState((prevState) => ({
            category: {
                ...prevState.category,
                playlist_category_status: value ? 1 : 0
            }
        }));
    }

    setRedirect = () => {
        this.setState({redirect: true});
    }

    setCategoryRedirect = (playlistCategoryId) => {
        this.setState({
            categoryRedirect: true,
            back_button_text: "Back",
            category: {
                ...this.state.category,
                playlist_category_id: playlistCategoryId
            }
        });
    }

    buildPayload = () => ({
        playlist_category: {
            playlist_category_id: this.state.category.playlist_category_id === "new" ? null : this.state.category.playlist_category_id,
            playlist_category_position: parseInt(this.state.category.playlist_category_position, 10) || 1,
            playlist_category_status: Number(this.state.category.playlist_category_status) === 1 ? 1 : 0,
            playlist_category_name: this.state.category.playlist_category_name,
            playlist_category_description: this.state.category.playlist_category_description,
            playlist_type: this.state.category.playlist_type,
            playlist_category_scope: this.state.category.playlist_category_scope,
            custom_data: null
        }
    })

    saveCategory = () => {
        const {handle} = this.props.match.params;
        const axiosConfig = this.getAxiosConfig();

        if (!axiosConfig) {
            return;
        }

        this.setState({loading: true});

        const payload = this.buildPayload();

        if (handle === "new") {
            apiClient.post(process.env.REACT_APP_API_URL + "/PlaylistCategory", payload, axiosConfig)
                .then((res) => {
                    const playlistCategoryId = res.data && res.data.playlist_category_id ? res.data.playlist_category_id : null;

                    this.setState({loading: false, showSaveModal: false});
                    this.notification("success");

                    if (playlistCategoryId) {
                        this.setCategoryRedirect(playlistCategoryId);
                    }
                })
                .catch(this.handleApiError);
        } else {
            apiClient.put(process.env.REACT_APP_API_URL + "/PlaylistCategory", payload, axiosConfig)
                .then(() => {
                    this.setState({loading: false, showSaveModal: false});
                    this.notification("success");
                    this.loadPageData();
                })
                .catch(this.handleApiError);
        }
    }

    setSaveModal = (value, action) => {
        this.setState({showSaveModal: value});

        if (action === "save") {
            this.saveCategory();
        }
    }

    renderSaveModal = () => {
        if (this.state.showSaveModal) {
            return <ModalSave
                headerMessage={"Playlist category: "}
                bodyMessage={"this action will save all changes, click close to cancel saving"}
                handlerFromParent={this.setSaveModal}
                handlerID={this.state.category.playlist_category_id}
            />;
        }
    }

    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect push to="/playlists/categories"/>;
        }

        if (this.state.categoryRedirect) {
            return <Redirect push to={"/playlists/categories/edit/" + this.state.category.playlist_category_id}/>;
        }
    }

    notification = (status) => {
        if (!this.state._notificationSystem) {
            return;
        }

        if (status === "success") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"/>),
                message: (
                    <div>
                        <b>Playlist category has been updated</b>
                    </div>
                ),
                level: "success",
                position: "tr",
                autoDismiss: 5
            });
        }

        if (status === "failed") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-times"/>),
                message: (
                    <div>
                        <b>Failed to save playlist category</b>
                    </div>
                ),
                level: "error",
                position: "tr",
                autoDismiss: 8
            });
        }
    }

    title = () => {
        if (!this.state.category.playlist_category_name) {
            return "New Playlist Category";
        }

        return this.state.category.playlist_category_name + " - Playlist Category";
    }

    renderUsageTable = () => {
        const columns = [
            {
                accessor: "playlist_name",
                Header: "Playlist",
                minWidth: 220
            },
            {
                accessor: "playlist_type",
                Header: "Type",
                minWidth: 140,
                Cell: (row) => formatPlaylistType(row.value)
            },
            {
                accessor: "playlist_delivery",
                Header: "Delivery",
                minWidth: 120,
                Cell: (row) => formatPlaylistDelivery(row.value)
            },
            {
                accessor: "playlist_item_count",
                Header: "Items",
                maxWidth: 80,
                Cell: (row) => <div className="center">{row.value || 0}</div>
            }
        ];

        return (
            <PlaylistScaffoldTable
                columns={columns}
                data={this.state.usageRows}
                loading={this.state.loading}
            />
        );
    }

    render() {
        const category = this.state.category;

        return (
            <div className="main-content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                {this.renderRedirect()}
                {this.renderSaveModal()}
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title={this.title()}
                                category={category.playlist_category_name === "" ? "New category" : category.playlist_category_name}
                                content={
                                    <div>
                                        <PlaylistScaffoldNotice title="Playlist Category">
                                            This form is now wired to the middleware category endpoints.
                                        </PlaylistScaffoldNotice>
                                        <Row>
                                            <Col md={7}>
                                                <FormGroup>
                                                    <p className="category">Status</p>
                                                    <Switch
                                                        value={category.playlist_category_status === 1}
                                                        onChange={(el, value) => this.handleSwitch(value)}
                                                    />
                                                </FormGroup>
                                                <FormGroup>
                                                    <ControlLabel>Name</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        name="playlist_category_name"
                                                        value={category.playlist_category_name}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter category name"
                                                        disabled={this.state.loading}
                                                    />
                                                </FormGroup>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup>
                                                            <ControlLabel>Position</ControlLabel>
                                                            <FormControl
                                                                type="number"
                                                                name="playlist_category_position"
                                                                value={category.playlist_category_position}
                                                                onChange={this.handleInputChange}
                                                                disabled={this.state.loading}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup>
                                                            <ControlLabel>Playlist Type</ControlLabel>
                                                            <FormControl
                                                                componentClass="select"
                                                                name="playlist_type"
                                                                value={category.playlist_type}
                                                                onChange={this.handleInputChange}
                                                                disabled={this.state.loading}
                                                            >
                                                                {playlistTypeOptions.map((option) => (
                                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                                ))}
                                                            </FormControl>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <FormGroup>
                                                    <ControlLabel>Scope</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="playlist_category_scope"
                                                        value={category.playlist_category_scope}
                                                        onChange={this.handleInputChange}
                                                        disabled={this.state.loading}
                                                    >
                                                        {categoryScopeOptions.map((option) => (
                                                            <option key={option.value} value={option.value}>{option.label}</option>
                                                        ))}
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup>
                                                    <ControlLabel>Description</ControlLabel>
                                                    <FormControl
                                                        componentClass="textarea"
                                                        name="playlist_category_description"
                                                        value={category.playlist_category_description}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Describe the editorial purpose of this category."
                                                        disabled={this.state.loading}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <Card
                                                    title="Usage Preview"
                                                    content={
                                                        <div>
                                                            <p><strong>Linked playlists:</strong> {category.playlist_count || this.state.usageRows.length}</p>
                                                            <p><strong>Type:</strong> {formatPlaylistType(category.playlist_type)}</p>
                                                            <p><strong>Scope:</strong> {formatCategoryScope(category.playlist_category_scope)}</p>
                                                            <p className="category">
                                                                Existing playlist usage is loaded from the middleware when editing an existing category.
                                                            </p>
                                                        </div>
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                        <legend/>
                                        {this.renderUsageTable()}
                                    </div>
                                }
                                legend={
                                    <div className="buttons-with-margin">
                                        <Button bsStyle="info" fill wd onClick={() => this.setState({showSaveModal: true})} disabled={this.state.loading}>
                                            {this.state.loading ? "Loading..." : this.props.t("global.save", {framework: "react-i18next"})}
                                        </Button>
                                        <Button bsStyle="default" fill wd onClick={this.setRedirect} disabled={this.state.loading}>
                                            {this.state.back_button_text}
                                        </Button>
                                    </div>
                                }
                                ftTextCenter
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {authentication} = state;
    const {user} = authentication;

    return {
        user
    };
}

const connectedEditPlaylistCategory = connect(mapStateToProps)(EditPlaylistCategory);
const connectedEditPlaylistCategoryTrans = withNamespaces("common")(connectedEditPlaylistCategory);
export const PlaylistCategoryEditScaffold = EditPlaylistCategory;
export const EditPlaylistCategoryTrans = connectedEditPlaylistCategoryTrans;
export {connectedEditPlaylistCategoryTrans as EditPlaylistCategory};
